var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcMainPage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.59998 1.89941C1.32383 1.89941 1.09998 2.12327 1.09998 2.39941C1.09998 2.67556 1.32383 2.89941 1.59998 2.89941L14.4 2.89941C14.6761 2.89941 14.9 2.67556 14.9 2.39941C14.9 2.12327 14.6761 1.89941 14.4 1.89941L1.59998 1.89941ZM8.79998 5.36608C8.52383 5.36608 8.29998 5.58994 8.29998 5.86608C8.29998 6.14222 8.52383 6.36608 8.79998 6.36608L14.4 6.36608C14.6761 6.36608 14.9 6.14222 14.9 5.86608C14.9 5.58994 14.6761 5.36608 14.4 5.36608L8.79998 5.36608ZM8.79998 8.83275C8.52383 8.83275 8.29998 9.05661 8.29998 9.33275C8.29998 9.60889 8.52383 9.83275 8.79998 9.83275L14.4 9.83275C14.6761 9.83275 14.9 9.60889 14.9 9.33275C14.9 9.05661 14.6761 8.83275 14.4 8.83275L8.79998 8.83275ZM1.59998 12.2994C1.32383 12.2994 1.09998 12.5233 1.09998 12.7994C1.09998 13.0756 1.32383 13.2994 1.59998 13.2994H14.4C14.6761 13.2994 14.9 13.0756 14.9 12.7994C14.9 12.5233 14.6761 12.2994 14.4 12.2994H1.59998ZM4.79998 5.09941H2.39998C1.68201 5.09941 1.09998 5.68144 1.09998 6.39941V8.79941C1.09998 9.51738 1.68201 10.0994 2.39998 10.0994H4.79998C5.51795 10.0994 6.09998 9.51738 6.09998 8.79941V6.39941C6.09998 5.68144 5.51795 5.09941 4.79998 5.09941Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMainPage);
export default __webpack_public_path__ + "static/media/ic-main-page.bd27656c93568c3e8b4d1a78ed0f62e5.svg";
export { ForwardRef as ReactComponent };